var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgParking = function SvgParking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4074_3294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6875 16.0938C14.6875 17.8196 13.2884 19.2188 11.5625 19.2188H8.4375C6.7116 19.2188 5.3125 17.8196 5.3125 16.0938V2.34375C5.3125 1.48082 6.01207 0.78125 6.875 0.78125H13.125C13.9879 0.78125 14.6875 1.48082 14.6875 2.34375V16.0938Z",
    stroke: "#919191",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5625 0.78125V2.34375C11.5625 3.20668 12.2621 3.90625 13.125 3.90625H14.6875",
    stroke: "#919191",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3125 8.59375C5.3125 8.59375 6.875 7.03125 10 7.03125C13.125 7.03125 14.6875 8.59375 14.6875 8.59375",
    stroke: "#919191",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3125 3.90625H6.875C7.73793 3.90625 8.4375 3.20668 8.4375 2.34375V0.78125",
    stroke: "#919191",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 10.1562L5.3125 8.59375",
    stroke: "#919191",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25 10.1562L14.6875 8.59375",
    stroke: "#919191",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.78125 19.2188V0.78125",
    stroke: "#919191",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2188 0.78125V19.2188",
    stroke: "#919191",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3125 12.9688C5.3125 13.8317 6.01207 14.5312 6.875 14.5312H13.125C13.9879 14.5312 14.6875 13.8317 14.6875 12.9688",
    stroke: "#919191",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4074_3294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
export default SvgParking;